const MediaBlocks = {
    blocks: [
        {
            title: 'SOCIAL_MONITORING',
            name: 'SOCIAL_MONITORING'
        },
        {
            title: 'LIVE_TRACKING',
            name: 'LIVE_TRACKING'
        },
        {
            title: 'REPUTATION_ANALYSIS',
            name: 'REPUTATION_ANALYSIS'
        },
        {
            title: 'HISTORICAL_ANALYSIS',
            name: 'HISTORICAL_ANALYSIS'
        },
        {
            title: 'CONTENT_ANALYSIS',
            name: 'CONTENT_ANALYSIS'
        },
        {
            title: 'WRITERS_RATING',
            name: 'WRITERS_RATING'
        }
    ]
}

export default MediaBlocks;